/*
 * @Author: Ashley.Liu
 * @Date: 2022-06-12 16:25:22
 * @LastEditTime: 2022-07-22 16:46:09
 * @Description: desc
 */
// debounce use in methods like save: debounce(()=>{}, 300)
export function debounce(fn, delay = 500) {
  let timer = null
  return function () {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments)
      timer = null
    }, delay)
  }
}

export const pinCache = {
  getPins() {
    if (localStorage.pinCache) {
      return JSON.parse(localStorage.pinCache)
    }
    return []
  },
  setPins(item) {
    const cache = pinCache.getPins()
    if (!cache.find((c) => c === item)) {
      cache.push(item)
    }
    localStorage.pinCache = JSON.stringify(cache)
    return cache
  },
  deletePin(item) {
    const cache = pinCache.getPins()
    const index = cache.findIndex((i) => i === item)
    cache.splice(index, 1)
    localStorage.pinCache = JSON.stringify(cache)
    return cache
  },
  has(item, list) {
    if (list) {
      return list.find((c) => c === item)
    }
    const cache = pinCache.getPins()
    return cache.find((c) => c === item)
  },
}

export function deepMap(arrayCollection, arrayMap) {
  return arrayCollection.concat(
    ...arrayMap.map((m) => {
      if (m.children) {
        return deepMap(new Array(1).fill(m.index), m.children)
      } else {
        return []
      }
    })
  )
}
